/**
 * Created with JetBrains RubyMine.
 * User: alex
 * Date: 5/23/13
 * Time: 4:32 PM
 * To change this template use File | Settings | File Templates.
 */

/*
 * Grab stored configuration from body tag(language, google analytics config)
 * and assign to global object
 */
window.grabPageConfig = function () {
  window.pageConfig = {};
  for (
    var attr, i = 0, attrs = document.body.attributes, l = attrs.length;
    i < l;
    i++
  ) {
    attr = attrs.item(i);
    var paramNameMatch = attr.nodeName.match(/^data-(.*)$/);
    if (paramNameMatch) {
      if (attr.nodeValue.match(/^{.*}$/)) {
        window.pageConfig[paramNameMatch[1]] = $.parseJSON(attr.nodeValue);
      } else {
        window.pageConfig[paramNameMatch[1]] = attr.nodeValue;
      }
    }
  }
};
